/**
 * Parent theme — le cockpit (Brand core V13).
 *
 * Ce que le parent porte en propre, par-dessus le socle marine partagé :
 *  - `role` = marine, la couleur de son univers (« marine côté parent », jamais mélangée) ;
 *  - `surface` = le fond de page `#F5F6F8`, au lieu de la feuille blanche neutre du socle ;
 *  - `surface-subtle` = la lavande, l'aplat des encarts (dernier bilan, scènes).
 *
 * Tout le reste — marine, jaune signature, progression, Outfit — vient de `baseTheme`.
 */
import { baseTheme } from "./base"
import { brand } from "./tokens/colors"

export const parentTheme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        role: brand.roleParent,
        surface: brand.page,
        "surface-subtle": brand.lavender,
    },
} as const
